export function HistoryClockIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.94531 4.25V6.69588H6.39121"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33316 10.0602C3.33316 13.7749 6.34458 16.7864 10.0594 16.7864C13.7741 16.7864 16.7855 13.7749 16.7855 10.0602C16.7855 6.3454 13.7741 3.33398 10.0594 3.33398C7.56999 3.33398 5.39645 4.68632 4.23338 6.69644"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.061 6.02344L10.0605 10.0621L12.9123 12.9138"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
